import * as React from "react";
const SvgFiRrAirPollution = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-air-pollution_svg__a)">
      <path
        fill="#062147"
        d="M14 4v-.5C14 1.57 15.57 0 17.5 0a3.4 3.4 0 0 1 1.585.387C19.552.21 20.26 0 21 0c1.654 0 3 1.346 3 3s-1.346 3-3 3a1 1 0 1 1 0-2 1 1 0 1 0 0-2c-.612 0-1.324.291-1.547.403a1 1 0 0 1-1.057-.095 1.5 1.5 0 0 0-.896-.309c-.827 0-1.5.673-1.5 1.5v.5A1 1 0 1 1 14 4M6 5a1 1 0 0 0 1-1v-.5C7 2.673 7.673 2 8.5 2c.404 0 .71.168.896.309.305.23.717.268 1.057.095.223-.112.936-.403 1.547-.403a1 1 0 1 0 0-2c-.74 0-1.448.21-1.915.387A3.43 3.43 0 0 0 8.5.001c-1.93 0-3.5 1.57-3.5 3.5v.5C5 4.554 5.448 5 6 5m10.746 15.255c.403.809.36 1.75-.114 2.518a2.57 2.57 0 0 1-2.201 1.228H2.548a2.57 2.57 0 0 1-2.202-1.228 2.57 2.57 0 0 1-.113-2.518l1.162-2.324a15.1 15.1 0 0 0 1.583-6.708V9c0-1.103.897-2 2-2h7.02c1.104 0 2 .897 2 2v2.223c0 2.317.549 4.637 1.585 6.708zM4.979 11.223q-.002.892-.1 1.777h7.22a17 17 0 0 1-.1-1.777V9H4.98zm9.978 9.927-1.162-2.324a17 17 0 0 1-1.364-3.825H4.549a17 17 0 0 1-1.364 3.825L2.023 21.15a.58.58 0 0 0 .025.571.58.58 0 0 0 .5.279H14.43a.58.58 0 0 0 .5-.279.58.58 0 0 0 .027-.571m7.605-3.219a15.1 15.1 0 0 1-1.583-6.708V9c0-1.103-.897-2-2-2h-2.021a1 1 0 1 0 0 2h2.02v2.223c0 .593.037 1.187.1 1.777H17a1 1 0 1 0 0 2h2.41a17 17 0 0 0 1.363 3.825l1.162 2.324a.58.58 0 0 1-.025.572.58.58 0 0 1-.5.278H20a1 1 0 1 0 0 2h1.41c.903 0 1.727-.459 2.202-1.228a2.57 2.57 0 0 0 .112-2.518l-1.162-2.324z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-air-pollution_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrAirPollution;
